import { Specialty, SpecialtyCodes } from '../../../domain/entities';
import { FirebaseSpecialty } from '../entities';

export class SpecialtyMapper {
  static toDomain(firebaseSpecialty: FirebaseSpecialty): Specialty {
    const code = SpecialtyCodes.find((code) => code === firebaseSpecialty.code);
    if (!code) throw new Error('Specialty code does not exists');

    return new Specialty({ ...firebaseSpecialty, code });
  }
}
